import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class TranslateService {
  lngData: any = {}; //this loaded from global variable ts file
  constructor() { }

  getLng(k: string) {
    return this.lngData[k];
  }
}